// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_0Gf","cls2":"RelatedWorksCard-cls2_B5g RelatedWorksCard-cls1_0Gf"};